import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';

import {LogService} from '../../../../services/log.service';


@Component({
	selector: 'expand',
	templateUrl: './expand.component.html',
	styleUrls: ['./expand.component.scss']
})
export class ExpandComponent implements OnInit, AfterViewInit {
	constructor(
		private log: LogService
	) {}


	expand = false;

	@Input() label = '';
	@Input() link = '';
	@Output() linkClick = new EventEmitter();


	ngOnInit() {
	}


	ngAfterViewInit() {
		// console.log('this.label');
		// console.log(this.label);
		// console.log('this.link');
		// console.log(this.link);
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/expand/expand.component.ts